import React from "react"
import BasePage from "../../components/layout/BasePage"
import { useQuery } from "@tanstack/react-query"
import { getAGB } from "./api/apiCalls"
import Loading from "../../components/common/Loading"
import BaseSection from "../../components/layout/BaseSection"
import ReactMarkdown from "react-markdown"
import { handleDownload } from "../../services/functions"
import { API } from "../../api/api"
import { ReactComponent as DOWNLOAD } from "../../assets/download.svg"

export default function AGB() {
    const { data, isLoading } = useQuery({
        queryKey: ["agb"],
        queryFn: () => getAGB(),
    })

    if (isLoading) {
        return <Loading />
    }

    return (
        <BasePage>
            <BaseSection flexCol classProps="px-4 xl:px-0">
                <div className="text-base-300 text-md markdown-content">
                    <ReactMarkdown>{data.content}</ReactMarkdown>
                </div>
                <button onClick={() => handleDownload(API.img + data?.agbFile?.data?.attributes?.url, "Wicode_AGB.pdf")}>
                    <div
                        className={`bg-primary cursor-pointer mt-4 flex w-80 justify-center items-center py-3 px-8 rounded-full gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                        <p className="lowercase text-accent text-sm">AGBs herunterladen</p>
                        <DOWNLOAD className="w-6 h-6 group-hover:translate-x-1 transition-all ease-in duration-200 pt-[2px]" />
                    </div>
                </button>
            </BaseSection>
        </BasePage>
    )
}
